import React, { useReducer, useState, useEffect, useContext } from 'react';
import { Layout, Menu, Icon, Row, Col, Spin } from 'antd';
import { Auth } from 'aws-amplify';
import { useHistory } from 'react-router';
import withSizes from 'react-sizes'
import CustomHeader from '../Header/index';
import NavBar from '..//Nav/index';
import Login from '../Login/index';
import isEqual from "lodash/isEqual";
import service from '../../Contexts/App/AppService';
import { AppContext, INITIAL_APP_STATE, appReducer } from '../../Contexts/App/AppContext';
import '../../assets/styles/global.scss'
import './styles/template.scss';
import { SearchOrderItemContext, INITIAL_SET_ORDER_ITEMS, SearchOrderItemReducer } from '../../Contexts/SearchOrderItem/SearchOrderItemContext';
import { browser } from '../../utils/helper';

const { Header, Content, Footer, Sider } = Layout;

function Template(props) {
    const history = useHistory();
    const [searchOrder, searchOrderDispatcher] = useReducer(SearchOrderItemReducer, INITIAL_SET_ORDER_ITEMS);

    const [app, appDispatcher] = useReducer(appReducer, INITIAL_APP_STATE);
    const [navBar, setnavBar] = useState({
        showNav: props.isMobileOrTab ? false : true,
        view: props.isMobileOrTab ? "mobile" : "web"
    });
    const appCtx = useContext(AppContext);
    const { isMobileOrTab } = props;

    const [loading, setLoading] = useState(false);
    const [navColSize, setnavColSize] = useState(4);
    const [contentColSize, setcontentColSize] = useState(20);

    useEffect(() => {
        checkSession();
    }, [])

    useEffect(() => {
        updateView()
    }, [isMobileOrTab])

    useEffect(() => {
        setLoading(appCtx.loading)
    }, [appCtx.loading])

    const checkSession = () => {
        Auth.currentSession()
            .then(session => {
                service.GetUserDetails(appCtx, res => {

                    if (res.flag) {
                        service.SetUserLogin(appCtx, true);
                        updateView(true);
                        return false;
                    } else return true;
                });
            })
            .then(ress => {
                if (ress) {
                    service.GetUserDetails(res => {
                        updateView(true);
                    });
                }
            })
            .catch(err => {
                service.SetUserLogin(appCtx, false);
                history.push('/login');
            });
    }

    const updateView = (didMount) => {
        if (isMobileOrTab && navBar.view !== "mobile") {
            let temp = navBar;
            temp.view = "mobile";
            setNav({ ...temp });
        }
        else if (navBar.view !== "web" && !didMount) {
            let temp = navBar;
            temp.view = "web";
            // temp.showNav = true;
            setNav({ ...temp });
        }
        else if (didMount)
            setdidMount()
    }
    const setdidMount = () => {
        if (isMobileOrTab) {
            let temp = navBar;
            temp.view = "mobile";
            setNav({ ...temp });
        }
        else {
            let temp = navBar;
            temp.view = "web";
            temp.showNav = true;
            setNav({ ...temp });
        }
    }
    const setNav = obj => {
        setnavBar({ ...obj });
        getNavColumnSpan({ ...obj })
        getContentSpan({ ...obj });
    }

    const getNavColumnSpan = (navBar) => {
        if (navBar) {
            if (navBar.view === "web") {
                setnavColSize(4)
            }
            else if (navBar.view === "mobile") {
                if (navBar.showNav) setnavColSize(24)
                else setnavColSize(0);
            }
        }
    }

    const getContentSpan = (navBar) => {
        if (navBar) {
            if (navBar.view === "web") {
                setcontentColSize(20)
            }
            else if (navBar.view === "mobile") {
                if (navBar.showNav) setcontentColSize(0)
                else setcontentColSize(24)
            }
        }
    }
    const getContent = () => {
        if (browser === 'edge') {
            return <div style={{
                height: '100vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                fontWeight: 'bold',
                fontSize: '21'
            }}>Not Supported on Edge</div>
        }
        else if (loading) {
            return (<Spin spinning={appCtx.loading} className="spinner-initial" size="large"></Spin>);
        }
        else {
            return (
                <Layout>
                    <Sider
                        breakpoint="md"
                        collapsedWidth="0"
                        width="250"
                        onBreakpoint={broken => {
                        }}
                        onCollapse={(collapsed, type) => {
                        }}
                    >
                        <NavBar />
                    </Sider>
                    <SearchOrderItemContext.Provider
                        value={{
                            ...searchOrder,
                            dispatch: searchOrderDispatcher,
                        }}>
                        <Layout>
                            {/* <Header style={{ background: '#fff', padding: 0 }} /> */}
                            <Header style={{
                                background: '#fff', padding: 0,
                                // position: relative;
                                // height: 70px;
                                boxShadow: 'rgba(0, 0, 0, 0.2) 0px 0px 50px 0px',
                            }}>
                                <CustomHeader />
                            </Header>
                            <Content className="hide-overflow">
                                {props.children}
                            </Content>
                            {/* <Footer style={{ textAlign: 'center' }}>PackageX 2020</Footer> */}
                        </Layout>
                    </SearchOrderItemContext.Provider>
                </Layout >
            );
        }
    }
    return (getContent());
}

export default Template;